export function getMediaUrl(url?: string | null) {
  if (!url) return "";
  if (url.startsWith("data:")) return url;
  if (/^https?:\/\//i.test(url)) return url;

  const apiBase = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
  const assetBase = apiBase.replace(/\/api\/?$/, "");
  const normalized = url.startsWith("/") ? url : `/${url}`;

  return `${assetBase}${normalized}`;
}